import { Button, type ButtonProps } from '@teamsparta/stack-button';

interface Props extends ButtonProps {
  active?: boolean;
}

export function Category({ active = false, children, style, ...props }: Props) {
  return (
    <Button
      variant={active ? 'solid' : 'outline'}
      radius='rounded'
      size='xs'
      colorScheme='secondary'
      style={{
        flexShrink: 0,
        border: '1px solid rgb(106, 113, 119)',
        ...style,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
